import { useState } from "react";
import { Volume2, Trash2, BookmarkX } from "lucide-react";
import { getBookmarks, removeBookmark } from "../bookmarks";

export default function Bookmarks() {
  const [bookmarks, setBookmarks] = useState(getBookmarks);

  function handleRemove(sentence) {
    removeBookmark(sentence);
    setBookmarks(getBookmarks());
  }

  function speak(text) {
    if ("speechSynthesis" in window) {
      const u = new SpeechSynthesisUtterance(text);
      u.rate = 0.85; u.lang = "en-US";
      window.speechSynthesis.speak(u);
    }
  }

  if (bookmarks.length === 0) {
    return (
      <div className="text-center py-10">
        <BookmarkX className="w-12 h-12 text-gray-300 mx-auto mb-4" />
        <h2 className="text-xl font-bold text-gray-400 mb-2">No bookmarks yet</h2>
        <p className="text-gray-400 text-sm">Save sentences from lessons and idioms to review later.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4 page-enter relative">
      <div className="blob blob-rose" style={{ width: 320, height: 320, top: -40, right: -40, opacity: 0.18 }} />
      <div className="blob blob-cyan" style={{ width: 260, height: 260, top: 280, left: -40, opacity: 0.15 }} />
      <div className="relative">
        <h1 className="font-display text-4xl md:text-5xl font-normal"><em>Saved.</em></h1>
        <p className="text-gray-600 dark:text-gray-300 font-semibold mt-1">{bookmarks.length} bookmarked</p>
      </div>
      <div className="space-y-3 page-enter">
        {bookmarks.map((b, i) => (
          <div key={i} className="bg-white rounded-xl border border-gray-100 p-4 flex items-center gap-3">
            <button onClick={() => speak(b.sentence)} className="p-2 text-gray-300 hover:text-gold-700 transition-colors flex-shrink-0">
              <Volume2 className="w-4 h-4" />
            </button>
            <div className="flex-1 min-w-0">
              <p className="font-medium text-gray-900 text-sm">{b.sentence}</p>
              <p className="text-xs text-gray-400 mt-0.5">{b.source}{b.day ? ` — Day ${b.day}` : ""}</p>
            </div>
            <button onClick={() => handleRemove(b.sentence)} className="p-2 text-gray-300 hover:text-berry transition-colors flex-shrink-0">
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
